import React, { Fragment, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { getCoches } from '../../../redux/DucksUnidadInspeccion/VehiculosDuck'
import { eliminarVehiculo } from '../../../redux/DucksUnidadInspeccion/VehiculosDuck'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faX, faPencilRuler, faAdd
} from '@fortawesome/free-solid-svg-icons'

import VehiculosFormComponent from './VehiculosFormComponent';

function VehiculosListComponent() {

    const dispatch = useDispatch()
    const vehiculos = useSelector(store => store.Vehiculos.coches)

    const [vehiculoModify, setVehiculoModify] = React.useState(null)
    const [openAgregarVehiculo, setOpenAgregarVehiculo] = React.useState(false);
    const [openEliminarVehiculo, setOpenEliminarVehiculo] = React.useState(false);


    React.useEffect(() => {
        dispatch(getCoches())
    }, []);

    React.useEffect(() => {
        dispatch(getCoches())
    }, [openAgregarVehiculo]);

    React.useEffect(() => {
        dispatch(getCoches())
    }, [openEliminarVehiculo]);

    React.useEffect(() => {
        dispatch(getCoches())
    }, [vehiculoModify]);

    React.useEffect(() => {
        vehiculos
    }, [vehiculos]);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 700,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };


    const handleOpenAgregarVehiculo = () => {
        setVehiculoModify(null)
        setOpenAgregarVehiculo(true)
    };

    const handleCloseAgregarVehiculo = () => {
        setVehiculoModify(null)
        setOpenAgregarVehiculo(false)
        dispatch(getCoches())
    };

    const handleOpenEliminarVehiculo = () => {
        setOpenEliminarVehiculo(true);
    }

    const handleCloseEliminarVehiculo = () => {
        setOpenEliminarVehiculo(false)
        dispatch(getCoches())
    };

    const handleModify = (vehiculo) => {
        handleOpenAgregarVehiculo()
        setVehiculoModify(vehiculo)
        dispatch(getCoches())
    }

    const handleDelete = (vehiculo) => {
        handleOpenEliminarVehiculo()
        setVehiculoModify(vehiculo)
        dispatch(getCoches())
    }

    const deleteVehiculo = (vehiculo) => {
        //console.log('El vehiculo es:' + JSON.stringify(vehiculo))
        dispatch(eliminarVehiculo((vehiculo.idautomovil)))
        setOpenEliminarVehiculo(false)
        dispatch(getCoches())
    }

    const modalAgregarVehículo = () => {
        return (
            <Fragment>
                {
                    <Modal
                        open={openAgregarVehiculo}
                        onClose={handleCloseAgregarVehiculo}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <VehiculosFormComponent vehiculoModify={vehiculoModify} onClose={handleCloseAgregarVehiculo}></VehiculosFormComponent>
                        </Box>

                    </Modal>
                }
            </Fragment>

        )
    }

    const modalEliminarVehiculo = () => {
        return (
            <Fragment>
                {
                    <Modal
                        open={openEliminarVehiculo}
                        onClose={handleCloseEliminarVehiculo}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style} className='text-center'>
                            <h4>¿Estás seguro que quieres Eliminar el vehiculo?</h4><br></br>
                            <button className='btn btn-danger' onClick={() => deleteVehiculo(vehiculoModify)}>Eliminar Vehículo</button>
                        </Box>

                    </Modal>
                }
            </Fragment>

        )
    }


    return (
        <Fragment><br />

            <h2>Parque Vehícular de Comercam Unidad de Inspección</h2><br />


            <div className='row'>
                <div className='col' style={{ textAlign: 'right' }}>
                    <button className='btn btn-success' onClick={handleOpenAgregarVehiculo}>
                        <FontAwesomeIcon icon={faAdd} />
                        Agregar Vehículo</button>
                </div>
            </div> <br />

            {
                vehiculos.map((vehiculo, index) => (

                    <div key={index} className={'alert alert-primary'} role="alert">

                        <div className='row'>
                            <div className='col-3'>
                                <img height={'100px'} src={'https://vw-villautosur.com.mx/Assets/ModelosNuevos/img/Modelos/SAVEIRO/23/Colores/blanco-candy.png'}></img>
                            </div>

                            <div className='col-6'>
                                <strong>Vehículo:</strong> ({vehiculo.idautomovil}) <br />
                                <strong> Marca: </strong>{vehiculo.marca} <br />
                                <strong> Modelo: </strong>{vehiculo.modelo} <br />
                                <strong> Color: </strong>{vehiculo.color} <br />
                                <strong> Placas: </strong>{vehiculo.placas} <br />
                            </div>
                            <div className='col-3'>
                                <h5>Opciones:</h5>

                                <button onClick={() => handleModify(vehiculo)} style={{ backgroundColor: 'orange' }} className='btn text-light'>
                                    <FontAwesomeIcon icon={faPencilRuler} />Editar</button>

                                <button onClick={() => handleDelete(vehiculo)} className='btn btn-danger'>
                                    <FontAwesomeIcon icon={faX} />Borrar</button>
                            </div>

                        </div>


                    </div>

                ))
            }
            {modalAgregarVehículo()}
            {modalEliminarVehiculo()}
        </Fragment>
    );
};


export default withRouter(VehiculosListComponent)
